exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#document-category-picker .dropdown[data-v-462c8810]{margin-bottom:15px}#document-category-picker .category_id[data-v-462c8810]{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-462c8810","scoped":true,"hasInlineConfig":false}!/~/sass-loader/lib/loader.js!/~/vue-loader/lib/selector.js?type=styles&index=0!./assets/js/vue/components/DocumentCategoryPicker.vue
// module id = 394
// module chunks = 0